import { Routes, Route } from 'react-router-dom'
import { WebFramePage } from './routes/web-frame/WebFramePage'
import { NotFoundPage } from './routes/NotFoundPage'
import { ConfirmEmailPage } from './routes/auth/ConfirmEmailPage'
import { PasswordRecoveryPage } from './routes/auth/PasswordRecoveryPage'

function App() {
  return (
    <Routes>
      {/* Store pages (Phase 2) */}
      <Route path="/" element={<HomePage />} />
      
      {/* Auth */}
      <Route path="/auth/confirm" element={<ConfirmEmailPage />} />
      <Route path="/auth/recovery" element={<PasswordRecoveryPage />} />
      
      {/* Quapp namespace */}
      <Route path="/quapps/:slug" element={<WebFramePage />} />
      <Route path="/quapps/:slug/details" element={<AppDetailsPage />} />
      
      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

// Placeholder components for Phase 2
function HomePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      <div className="text-center p-8">
        <h1 className="text-3xl font-bold text-primary mb-4">Quapp Store</h1>
        <p className="text-gray-600 mb-6">Coming soon...</p>
        <p className="text-sm text-gray-500">
          Try: <a href="/quapps/hello7" className="text-primary hover:underline">/quapps/hello7</a>
        </p>
      </div>
    </div>
  )
}

function AppDetailsPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      <div className="text-center p-8">
        <h1 className="text-2xl font-bold mb-4">App Details</h1>
        <p className="text-gray-600">Coming in Phase 2...</p>
      </div>
    </div>
  )
}

export default App
